import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import scroll from 'vue-seamless-scroll'
import router from "./router";
// import analytics from '@/utils/analytics';
// import analyticsDirective from '@/directives/analytics';

// 导入 Vant 样式
import 'vant/lib/index.css';

import { Toast } from "vant";

Vue.use(Toast).use(scroll);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

// 注册指令
// Vue.directive('analytics', analyticsDirective);

// // 添加混入
// Vue.mixin({
//   mounted() {
//     // 记录页面访问
//     analytics.trackPageView();
    
//     // 记录停留时长
//     window.addEventListener('beforeunload', () => {
//       analytics.trackTimeSpent();
//     });
//   }
// });

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");